export const pop = ()=> {
    const pop = document.querySelector('.product-hero__pop')

    let startClick = false

    window.addEventListener('click',(e)=> {
        if (e.target.closest('.product-hero__link') && !startClick) {
            e.preventDefault();
            pop.classList.add('show')
            document.body.classList.add('pop-overflow-hidden');
            startClick = true
        } else if (e.target.closest('.product-hero__pop-cross') || e.target === pop && startClick) {
            pop.classList.remove('show')
            document.body.classList.remove('pop-overflow-hidden');
            startClick = false
        }
    })

    pop?.querySelector('form')?.addEventListener('wpcf7mailsent', () => {
        setTimeout(()=> {
            pop.classList.remove('show')
            document.body.classList.remove('pop-overflow-hidden');
            startClick = false
        },14000)
    })
    
}